/* eslint-disable no-restricted-properties */

import type { ZodError } from "zod"

export const createCIEnvValidationHandler =
  (NOT_AVAILABLE_ON_CI: string[]) =>
  (error: ZodError): never => {
    const flattenedErrors = error.flatten().fieldErrors
    if (process.env.CI) {
      const errors = Object.keys(flattenedErrors).filter(error => !NOT_AVAILABLE_ON_CI.includes(error))
      if (errors.length === 0) {
        console.log("⚠️ CI detected, skipping error for:", Object.keys(flattenedErrors).join(", "))

        // Use env variable CI whitelist to check when not to throw an error - only throw if there is an error thats not whitelisted, or we are not in CI
        // @ts-expect-error function expects to always throw error, but that's not the case here
        return
      }

      console.log("⚠️ CI detected, not skippable errors - consider checking NOT_AVAILABLE_ON_CI whitelist:", flattenedErrors)
    }

    console.error("❌ Invalid environment variables:", flattenedErrors)
    throw new Error("Invalid environment variables")
  }
